import apis from "../../../api";
import { errorTypes } from "../../../utils/errorTypes";
import { seriesManagement } from "../../../utils/mainTabs/organize/seriesManagement";
import {
  setShotClassDataAction,
  setProgramDataAction,
  setSeriesShotclassDataAction,
  setClassAndCollectionDataByID,
} from "../actionCreators/organizeActionCreator";
import { setErrorHandler } from "./errorActionHandler";

export const getAllGroupTopicsActionHandler =
  (
    searchText,
    pageNo,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows
  ) =>
  async () => {
    await apis.organize
      .getAllGroupTopics(searchText, pageNo, pageSize)
      .then((response) => {
        setUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAllTopicsActionHandler =
  (
    searchText,
    pageNo,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows
  ) =>
  async () => {
    await apis.organize
      .getAllTopics(searchText, pageNo, pageSize)
      .then((response) => {
        setUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAllTopicsAfterSearchActionHandler =
  (searchText, pageNo, pageSize, setData) => async () => {
    return await apis.organize
      .getAllTopics(searchText, pageNo, pageSize)
      .then((response) => {
        setData(response?.data?.Content);
        return response?.data?.Content;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const availableTopicActionHandler =
  (searchText = "", pageNo = 0, pageSize = 8, setState) =>
  async () => {
    return await apis.organize
      .getAllTopics(searchText, pageNo, pageSize)
      .then((response) => {
        if (response?.data?.Content) {
          const updatedData = response?.data?.Content?.map((item) => {
            return {
              ...item,
            };
          });
          setState(updatedData);
          return updatedData;
        } else {
          setState(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAllProgramsCountOrganizeWithoutConditionActionHandler =
  (status, classtype, filters, setState) => async () => {
    await apis.organize
      .getAllProgramsCountOrganizeWithoutCondition(status, classtype, filters)
      .then((response) => {
        if (response) {
          setState(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getRecentlyAddedProgramsActionHandler =
  (
    Condition,
    Status,
    classtype,
    filters,
    locale,
    pageNum,
    pageSize,
    setUsersData,
    setTempUsersData,
    // setTotalRows,
    setProgramData
  ) =>
  async () => {
    await apis.organize
      .getRecentlyAddedPrograms(
        Condition,
        Status,
        classtype,
        filters,
        false,
        locale,
        pageNum,
        pageSize
      )
      .then((response) => {
        if (response?.data) {
          response.data.forEach((data) => {
            setProgramData((prevState) => {
              return [...prevState, data?.Programs?.Name];
            });
          });
        }
        setUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Programs,
        ]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Programs,
        ]);
        // setTotalRows(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postImageActionHandler = (data, setImgUrl) => async () => {
  const formData = new FormData();
  formData.append("file", data?.[0]);
  return await apis.social
    .postImage(formData)
    .then((response) => {
      setImgUrl(response.data);
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addGroupTopicActionHandler = (data) => async () => {
  return await apis.organize
    .addGroupTopic(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const isTopicExistsActionHandler =
  (searchText, setState) => async (dispatch) => {
    // dispatch(
    //   loaders.manage.createShotclasses.isShotclassNameExistsLoader(true)
    // );
    await apis.organize
      .isTopicExists(searchText)
      .then((response) => {
        if (response.data) {
          setState(response.data);
        } else {
          setState(null);
        }
        // dispatch(
        //   loaders.manage.createShotclasses.isShotclassNameExistsLoader(false)
        // );
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getSearchTopicTagsActionHandler =
  (searchText, setState) => async (dispatch) => {
    // dispatch(loaders.manage.createShotclasses.getShotClassTagLoader(true));
    await apis.organize
      .getSearchTopicTags(searchText)
      .then((response) => {
        let data = response?.data?.map((tag) => {
          return { TagName: tag, TagValue: tag };
        });
        setState(data);
        // dispatch(loaders.manage.createShotclasses.getShotClassTagLoader(false));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getRecentlyAddedProgramsTopicActionHandler =
  (
    Condition,
    Status,
    classtype,
    filters,
    isPublishedContentOnly,
    locale,
    pageNum,
    pageSize,
    checkingTrueOrFalse
  ) =>
  async (dispatch, getState) => {
    return await apis.organize
      .getRecentlyAddedPrograms(
        Condition,
        Status,
        classtype,
        filters,
        isPublishedContentOnly,
        locale,
        pageNum,
        pageSize
      )
      .then((response) => {
        if (response) {
          // debugger;
          // if (pageNum < 2) {
          //   dispatch(setShotClassDataAction([]));
          // }
          if (classtype === "ShotClass") {
            if (pageNum == "1" && checkingTrueOrFalse) {
              dispatch(setShotClassDataAction([]));
            }
            const shotClassData = getState().organizeReducer?.shotClassData;
            dispatch(
              setShotClassDataAction([...shotClassData, ...response?.data])
            );
            return response;
          } else if (classtype === "Program") {
            if (pageNum == "1" && checkingTrueOrFalse) {
              dispatch(setProgramDataAction([]));
            }
            const programData = getState().organizeReducer?.programData;
            dispatch(setProgramDataAction([...programData, ...response?.data]));
            return response;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const addTopicActionHandler = (data) => async () => {
  return await apis.organize
    .addTopic(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getTopicDetailsByProgramIDActionHandler =
  (data, setTopicCourseAssociations) => async () => {
    await apis.organize
      .getTopicDetailsByProgramID(data)
      .then((response) => {
        if (response.status == 200) {
          setTopicCourseAssociations(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getRecentlyAddedProgramsSeriesMgmtActionHandler =
  (
    searchText = "",
    pageNum,
    pageSize,
    setProgramData,
    setTempProgramData,
    setTotalRows,
    Condition = "WithoutVTLT",
    Status = "Published",
    classtype = "Program",
    filters,
    locale = "none"
  ) =>
  async () => {
    await apis.organize
      .getRecentlyAddedProgramsSeriesMgmt(
        Condition,
        Status,
        classtype,
        filters,
        locale,
        pageNum,
        pageSize
      )
      .then((response) => {
        if (response) {
          const updatedData = response.data.map((item) => {
            return {
              ...item?.Programs,
              checked: item?.Programs?.IsPublished,
            };
          });
          setProgramData((prevStateData) => [...prevStateData, ...updatedData]);
          setTempProgramData((prevStateData) => [
            ...prevStateData,
            ...updatedData,
          ]);
          setTotalRows(response?.data?.TotalRows);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getRecentlyAddNewSeriesActionHandler =
  (
    Condition = "WithoutVTLT",
    Status = "Published",
    classtype = "Program",
    filters = "none",
    locale = "none",
    pageNum,
    pageSize,
    searchTrue
  ) =>
  async (dispatch, getState) => {
    return await apis.organize
      .getRecentlyAddedProgramsSeriesMgmt(
        Condition,
        Status,
        classtype,
        filters,
        locale,
        pageNum,
        pageSize
      )
      .then((response) => {
        if (response) {
          if (searchTrue && pageNum < 2) {
            const seriesData = getState()?.organizeReducer?.seriesShotclassData;
            // console.log("if search hai", seriesData);
            dispatch(setSeriesShotclassDataAction([]));
          }
          if (classtype === "ShotClass") {
            const seriesData = getState()?.organizeReducer?.seriesShotclassData;
            // console.log("if search nahi h", seriesData);
            dispatch(
              setSeriesShotclassDataAction([...seriesData, ...response?.data])
            );
          }
          return response;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const updateProgramActionHandler =
  (data, navigate, tenantName) => async (dispatch) => {
    return await apis.organize
      .updateProgram(data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setErrorHandler(errorTypes.FAIL, "Program has failed to update")
        );
        navigate(seriesManagement?.path(tenantName));
      });
  };

export const isNameExistActionHandler =
  (searchText, type = "program", setState) =>
  async (dispatch) => {
    // dispatch(
    //   loaders.manage.createShotclasses.isShotclassNameExistsLoader(true)
    // );
    await apis.organize
      .isNameExist(searchText, type)
      .then((response) => {
        if (response.data) {
          setState(response.data);
        } else {
          setState(null);
        }
        // dispatch(
        //   loaders.manage.createShotclasses.isShotclassNameExistsLoader(false)
        // );
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getSearchProgramTagsActionHandler =
  (searchText, setState) => async () => {
    await apis.organize
      .getSearchProgramTags(searchText)
      .then((response) => {
        if (response.data) {
          let data = response?.data?.map((tag) => {
            return { TagName: tag, TagValue: tag };
          });
          setState(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postSeriesProgramActionHandler =
  (data, dispatch, navigate, pathType, tenantName) => async () => {
    return await apis.organize
      .postSeriesProgram(data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setErrorHandler(
            errorTypes.FAIL,
            pathType === "copy"
              ? "Program has failed to copy"
              : pathType === "edit"
              ? "Program has failed to save"
              : "Program has failed to create"
          )
        );
        navigate(seriesManagement.path(tenantName));
      });
  };

export const getClassAndCollectionByProgramIdActionHandler =
  (ProgramID, locale) => async (dispatch) => {
    return await apis.admin.groupManagement
      .getClassAndCollectionByProgramId(ProgramID, locale)
      .then((response) => {
        if (response) {
          // setData(response?.data);
          dispatch(setClassAndCollectionDataByID(response?.data));
        }
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const deleteProgramActionHandler =
  (programId, setData, setLoader) => async () => {
    setLoader(true);
    return await apis.distribute
      .deleteProgram(programId)
      .then((response) => {
        if (response) {
          setData(response?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getTopicByIDActionHandler = (dataID) => async () => {
  return await apis.organize
    .getTopicByID(dataID)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteTopicByIDActionHandler = (dataID) => async () => {
  return await apis.organize
    .deleteTopicByID(dataID)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateTopicActionHandler = (data) => async () => {
  return await apis.organize
    .updateTopic(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateGroupTopicActionHandler = (data) => async () => {
  return await apis.organize
    .updateGroupTopic(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getGroupTopicByIDActionHandler = (groupTopicID) => async () => {
  return await apis.organize
    .getGroupTopicByID(groupTopicID)
    .then((response) => {
      if (response) {
        return response;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserGroupsActionHandler = (setData) => async (dispatch) => {
  // dispatch(loaders.manage.createShotclasses.getUserGroupsLoader(true));
  return await apis.manage
    .getUserGroups()
    .then((response) => {
      // setData(response.data.UserGroups);
      return response.data?.UserGroups;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      // dispatch(loaders.manage.createShotclasses.getUserGroupsLoader(false));
    });
};

export const searchProgramActionHandler =
  (SearchText, Status, locale, classtype, searchTxtValue, condition) =>
  async (dispatch, getState) => {
    return await apis.organize
      .searchSeriesProgram(SearchText, Status, locale, condition)
      .then((response) => {
        if (response) {
          // console.log("search",response.data)
          if (classtype == "Shotclass" && searchTxtValue) {
            // debugger;
            dispatch(setSeriesShotclassDataAction([]));
            const searchData = response?.data?.filter(
              (item) => item?.ShotClass !== null
            );
            // console.log(searchData);
            // setResult(searchData)
            return searchData;
            // const seriesData = getState().organizeReducer?.seriesShotclassData;
            // dispatch(
            //   setSeriesShotclassDataAction(searchData)
            // );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const searchProgramForNewTopicActionHandler =
  (SearchText, Status, locale, classtype, searchTxtValue) =>
  async (dispatch, getState) => {
    return await apis.organize
      .searchSeriesProgram(SearchText, Status, locale)
      .then((response) => {
        if (response) {
          if (classtype === "ShotClass") {
            const updatedShotclassData = response?.data?.filter(
              (item) => item?.ShotClass !== null
            );
            // const shotClassData = getState().organizeReducer?.shotClassData;
            // dispatch(
            //   setShotClassDataAction([...shotClassData, updatedShotclassData])
            // );
            return updatedShotclassData;
          } else if (classtype === "Program") {
            const updatedProgramData = response?.data?.filter(
              (item) => item?.Programs !== null
            );
            // const programData = getState().organizeReducer?.programData;
            // dispatch(
            //   setProgramDataAction([...programData, updatedProgramData])
            // );
            return updatedProgramData;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postEditSeriesCertificateActionHandler = (data) => async () => {
  return await apis.organize
    .editCertificate(data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
